import React from "react";
import PageHeading from "../../components/PageHeading";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useQueries, useQueryClient } from "react-query";
import productServices from "../../services/products";
import providerServices from "../../services/ApiProviders";
import DCard from "../../components/DCard";
import DSpinner from "../../components/DSpinner";
import ProductSubForm from "../../components/Forms/ProductSubForm";
import * as Yup from "yup";
import {
  imageFormat,
  imageSize,
  formattedProviders,
} from "../../utils/functions";
import { toast } from "react-hot-toast";
const validationSchema = Yup.object().shape({
  productImage: Yup.mixed()
    .test("image-format", "يرجى تحميل صورة", (value) => {
      if (value) {
        if (value?.type) {
          return imageFormat.includes(value.type.split("/")[1]);
        }
        return true;
      } else {
        return false;
      }
    })
    .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", (value) => {
      if (value) {
        if (value?.type) {
          return imageSize >= value.size;
        }
        return true;
      } else {
        return false;
      }
    })
    .required("الصورة مطلوبة"),
  productName: Yup.string()
    .required("هذا الحقل مطلوب")
    .min(3, "يجب اني يكون على الاقل 3 احرف"),
  productId: Yup.string().when("isAuto", {
    is: true,
    then: () => Yup.string().required("هذا الحقل مطلوب"),
  }),
  provider: Yup.string().when("isAuto", {
    is: true,
    then: () => Yup.string().required("هذا الحقل مطلوب"),
  }),
  productPrice1: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(0, "يجب ان يكون اكبر من الصفر")
    .required("هذا الحقل مطلوب"),
  productPrice2: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(0, "يجب ان يكون اكبر من الصفر")
    .required("هذا الحقل مطلوب"),
  productPrice3: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(0, "يجب ان يكون اكبر من الصفر")
    .required("هذا الحقل مطلوب"),
  offerPrice1: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(-1, "يجب ان يكون اكبر او يساوي الصفر")
    .notRequired(),

  offerPrice2: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(-1, "يجب ان يكون اكبر او يساوي الصفر")
    .notRequired(),
  offerPrice3: Yup.number()
    .typeError("يجب ان يكون رقم")
    .moreThan(-1, "يجب ان يكون اكبر او يساوي الصفر")
    .notRequired(),
});

const EditSubProduct = ({ title }) => {
  const { id, subId } = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const results = useQueries([
    {
      queryKey: ["getProduct", id],
      queryFn: () => productServices.getProduct(id),
    },
    {
      queryKey: ["getSubProduct", subId],
      queryFn: () => productServices.getSubProduct(subId),
    },
    {
      queryKey: "getAllProviders",
      queryFn: () => providerServices.getAllProviders(),
    },
  ]);
  const [
    { data: product },
    { data: subproduct, isLoading, error },
    { data: providers, isLoading: providersIsLoading },
  ] = results;

  const formattedData = (subData, data) => {
    return {
      productName: subData.name,
      productImage: subData.img,
      productPrice1: subData.price.level_one,
      productPrice2: subData.price.level_two,
      productPrice3: subData.price.level_three,
      offerPrice1: !subData.price.offer_one ? "" : subData.price.offer_one,
      offerPrice2: !subData.price.offer_two ? "" : subData.price.offer_one,
      offerPrice3: !subData.price.offer_three ? "" : subData.price.offer_three,
      productId: !subData.api_id ? "" : subData.api_id,
      isAuto: subData.api_id ? true : false,
      countable: subData.countable === 1 ? true : false,
      productPrimaryName: data?.name,
      is_available: subData.is_available === 1 ? true : false,
      noteAr: subData.note_ar === "undefined" ? "" : subData.note_ar,
      noteEn: subData.note_en === "undefined" ? "" : subData.note_en,
      qty_max: subData.qty_max,
      qty_min: subData.qty_min,
      provider: subData.api_provider_id ? subData.api_provider_id : "",
    };
  };

  const onSubmit = (values, { setSubmitting }) => {
    const formateData = {
      name: values.productName,
      is_available: values.is_available,
      countable: values.countable,
      api_id: values.isAuto ? values.productId : null,
      api_provider_id: values.isAuto ? values.provider : null,
      price: {
        level_one: values.productPrice1,
        level_two: values.productPrice2,
        level_three: values.productPrice3,
        offer_one: values.offerPrice1 === "" ? null : values.offerPrice1,
        offer_two: values.offerPrice2 === "" ? null : values.offerPrice2,
        offer_three: values.offerPrice3 === "" ? null : values.offerPrice3,
      },
      note_ar: values.noteAr,
      note_en: values.noteEn,
      qty_max: values.qty_max,
      qty_min: values.qty_min,
    };
    productServices
      .editSubProduct(formateData, subId)
      .then((res) => {
        if (values.productImage !== subproduct.data.img) {
          const formData = new FormData();
          formData.append("img", values.productImage);
          productServices
            .editSubProductImage(formData, subId)
            .then((res) => {
              toast.success("تم التحديث بنجاح");
              queryClient.refetchQueries("getSubProducts");
              setTimeout(() => {
                navigate(`/products/${id}`);
              }, 1500);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toast.success("تم التحديث بنجاح");
          queryClient.refetchQueries("getSubProducts");
          setTimeout(() => {
            navigate(`/products/${id}`);
          }, 1500);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 404) {
          toast.error("السجل غير موجود");
        } else {
          toast.error("فشل التحديث");
        }
        setTimeout(() => {
          setSubmitting(false);
        }, 1500);
      });
  };
  if (isNaN(Number(id)) || !id || isNaN(Number(subId)) || !subId || error) {
    return <Navigate to="/404" />;
  }

  return (
    <div>
      <PageHeading>{title}</PageHeading>
      <DCard
        className={
          isLoading || providersIsLoading ? "relative min-h-[400px]" : ""
        }
      >
        {isLoading || providersIsLoading ? (
          <DSpinner />
        ) : (
          <ProductSubForm
            validationSchema={validationSchema}
            initialValues={formattedData(subproduct.data, product?.data.data)}
            providersOptions={formattedProviders(providers.data)}
            onSubmit={onSubmit}
            btnText={"تعديل الباقة"}
          />
        )}
      </DCard>
    </div>
  );
};

export default EditSubProduct;
